<button class="spinner" mat-flat-button color="primary" [disabled]="true" *ngIf="showSpinner">
  <ng-content></ng-content> <mat-spinner [diameter]="24"></mat-spinner>
</button>

<button *ngIf="!showSpinner" mat-flat-button color="primary" [disabled]="!active">
  <ng-content></ng-content>
</button>
